import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

const principles = [
  { icon: "ri-archive-drawer-line", t: "客观整理", d: "角色设定与名场面以原作信息为依据，力求还原，不做过度臆造。" },
  { icon: "ri-settings-3-line", t: "系统分类", d: "按作品与设定两大维度建立谱系，让角色之间彼此串联、方便检索。" },
  { icon: "ri-refresh-line", t: "持续更新", d: "随新作连载与高人气的涌现，定期补充新角色与作品专题。" },
  { icon: "ri-heart-line", t: "尊重热爱", d: "以爱发电的内容站，每一份整理都献给真正热爱女神的你。" },
];

const testimonials = [
  { quote: "想补全《星穹之下》的设定时，靠这里的角色档案省了好多时间，名场面整理得特别走心。", name: "追漫十年的阿澈", role: "星穹之下 忠实读者" },
  { quote: "按作品分好类这一点太棒了，想了解哪个神系就点进哪个，一目了然。", name: "阿玖", role: "和风奇幻爱好者" },
  { quote: "人气值排行很对我的胃口，每次新作更新都会先来图鉴看看新女神。", name: "樱酱", role: "泛动漫读者" },
];

export default function About() {
  usePageMeta(
    "关于我们｜女神漫画角色图鉴",
    "了解女神漫画角色图鉴的品牌定位、内容原则与用户口碑。我们以系统化整理高人气女神漫画角色为使命，用热爱与专业打造属于每一位读者的角色大全。"
  );

  return (
    <>
      <section className="relative flex min-h-[260px] md:min-h-[300px] w-full items-center overflow-hidden bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=ethereal%20warm%20glow%20of%20a%20goddess%20sanctuary%20library%20with%20floating%20books%20and%20constellation%20light%2C%20wide%20fantasy%20anime%20banner%2C%20amber%20crimson%20and%20ivory%20palette%2C%20soft%20luminous%20warm%20atmosphere&width=1600&height=600&seq=about-banner-2026&orientation=landscape"
          alt="关于我们横幅背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pt-16 pb-8 text-white md:pt-24">
          <nav aria-label="面包屑" className="text-xs text-white/70">
            <span className="hover:text-white"><a href="/" rel="nofollow">首页</a></span>
            <span className="mx-2">/</span>
            <span>关于我们</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-black md:text-5xl">关于我们</h1>
          <p className="mt-4 max-w-2xl text-sm text-white/80 md:text-base">
            以热爱为名，为每一位追漫的你整理一份属于女神角色的完整图鉴。
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <p className="text-sm font-medium text-primary-600">W H O &nbsp;W E &nbsp;A R E</p>
              <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">品牌介绍</h2>
              <p className="mt-5 text-sm leading-loose text-foreground-700 md:text-base">
                女神漫画角色图鉴是一份面向泛动漫读者的女神角色整理站。我们相信，每一部作品里的女神角色都承载着读者特殊的记忆与情感——她们或是温柔坚定的守护者，或是热烈洒脱的霞光，或是沉静包容的海洋。
              </p>
              <p className="mt-4 text-sm leading-loose text-foreground-700 md:text-base">
                因此我们用心按作品与设定两大维度，将高人气女神漫画角色分类整理成完整的角色大全，让每一位读者都能快速认识角色、补全设定，在追漫之前先做足功课。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["角色大全", "设定整理", "名场面", "作品谱系", "持续更新"].map((t) => (
                  <span key={t} className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800 whitespace-nowrap">
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://readdy.ai/api/search-image?query=ethereal%20goddess%20holding%20an%20open%20glowing%20book%20surrounded%20by%20stars%20and%20floating%20petals%2C%20fantasy%20anime%20portrait%2C%20warm%20gold%20and%20rose%20accents%2C%20luminous%20magical%20atmosphere&width=700&height=900&seq=about-col-1&orientation=portrait"
                alt="捧书的女神角色插画"
                className="mt-6 h-full w-full rounded-lg object-cover object-top"
              />
              <img
                src="https://readdy.ai/api/search-image?query=graceful%20goddess%20releasing%20doves%20of%20light%20in%20a%20warm%20sunrise%20sanctuary%2C%20fantasy%20anime%20portrait%2C%20ivory%20amber%20and%20crimson%20palette%2C%20serene%20hopeful%20atmosphere&width=700&height=900&seq=about-col-2&orientation=portrait"
                alt="晨光中的女神角色插画"
                className="h-full w-full rounded-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="text-center">
            <p className="text-sm font-medium text-primary-600">O U R &nbsp;P R I N C I P L E S</p>
            <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">内容原则</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
              我们坚持用专业、客观与热爱打磨每一份角色档案。
            </p>
          </div>
          <div className="mt-9 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((p) => (
              <div key={p.t} className="rounded-lg border border-background-200 bg-background-50 p-6 text-center">
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/10 text-primary-600">
                  <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">{p.t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="text-center">
            <p className="text-sm font-medium text-primary-600">T E S T I M O N I A L S</p>
            <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">读者口碑</h2>
          </div>
          <div className="mt-9 grid gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-lg border border-background-200 bg-background-100 p-6">
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill" aria-hidden="true"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">“{t.quote}”</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-50">
                    {t.name.charAt(0)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-3xl px-4 text-center md:px-6">
          <p className="text-sm font-medium text-primary-600">C O N T A C T</p>
          <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">联系我们</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            如果你有喜欢的女神角色想分享、想推荐收录的作品，或对本图鉴有任何建议，欢迎通过以下方式与我们联系。我们珍视每一份来自读者的声音。
          </p>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
              contact@goddess.example
            </span>
            <Link
              to="/characters"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap hover:bg-primary-600"
            >
              先去看看角色
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}